// Tabella FISSA "RID / Mandati bancari" — valida fino a revoca (non annuale).
// Import da Excel (Nominativo / Settore classe / IBAN), collegamento all'alunno via CF.
import { useEffect, useMemo, useRef, useState } from "react";
import api from "@/lib/api";

const todayDmy = () => {
  const d = new Date();
  return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
};

function LinkModal({ rid, onClose, onLinked }) {
  const [q, setQ] = useState(rid.nominativo || "");
  const [res, setRes] = useState([]);
  const [loading, setLoading] = useState(false);
  const search = async () => {
    if (q.trim().length < 2) return;
    setLoading(true);
    try { const r = await api.get("/rid/alunni-search", { params: { q: q.trim() } }); setRes(r.data?.items || []); }
    catch { setRes([]); } finally { setLoading(false); }
  };
  const pick = async (a) => {
    try { const r = await api.post(`/rid/${rid.id}/link`, { codice_fiscale: a.codice_fiscale }); onLinked(r.data); }
    catch (e) { alert(e.response?.data?.detail || "Errore collegamento"); }
  };
  return (
    <div data-testid="rid-link-modal" onClick={onClose}
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: "white", width: 520, maxWidth: "95vw", maxHeight: "85vh", borderRadius: 8, overflow: "hidden", display: "flex", flexDirection: "column" }}>
        <div style={{ background: "#00695c", color: "white", padding: "12px 16px", display: "flex", justifyContent: "space-between" }}>
          <b>🔗 Collega a un alunno — {rid.nominativo}</b>
          <button onClick={onClose} style={{ background: "none", border: "none", color: "white", cursor: "pointer", fontSize: 18 }}>✕</button>
        </div>
        <div style={{ padding: 14 }}>
          <div style={{ display: "flex", gap: 6 }}>
            <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && search()}
              data-testid="rid-link-search" placeholder="Cognome Nome o Codice Fiscale…"
              style={{ flex: 1, padding: "8px 10px", border: "1px solid #ccc", borderRadius: 4, fontSize: 13 }} />
            <button onClick={search} data-testid="rid-link-search-btn" style={{ padding: "8px 14px", background: "#00695c", color: "white", border: "none", borderRadius: 4, fontWeight: 700, cursor: "pointer" }}>Cerca</button>
          </div>
          <div style={{ marginTop: 10, maxHeight: 320, overflowY: "auto", border: "1px solid #eee", borderRadius: 4 }}>
            {loading && <div style={{ padding: 12, color: "#888" }}>Ricerca…</div>}
            {!loading && res.length === 0 && <div style={{ padding: 12, color: "#888", fontSize: 13 }}>Nessun risultato.</div>}
            {res.map((a) => (
              <div key={a.cod} data-testid={`rid-link-opt-${a.cod}`} onClick={() => pick(a)}
                style={{ padding: "8px 12px", borderBottom: "1px solid #f0f0f0", cursor: "pointer", display: "flex", justifyContent: "space-between", gap: 8 }}
                onMouseEnter={(e) => e.currentTarget.style.background = "#e0f2f1"} onMouseLeave={(e) => e.currentTarget.style.background = "white"}>
                <span><b>{a.cognome} {a.nome}</b> <span style={{ color: "#888", fontSize: 12 }}>{a.settore} {a.classe}</span></span>
                <span style={{ fontFamily: "monospace", fontSize: 11, color: "#666" }}>{a.codice_fiscale}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default function RidAlunniPage() {
  const [data, setData] = useState({ items: [], total: 0, count_attivi: 0, count_non_collegati: 0 });
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);
  const [search, setSearch] = useState("");
  const [soloNonCollegati, setSoloNonCollegati] = useState(false);
  const [soloAttivi, setSoloAttivi] = useState(false);
  const [importing, setImporting] = useState(false);
  const [importRes, setImportRes] = useState(null);
  const [linkRid, setLinkRid] = useState(null);
  const fileRef = useRef(null);

  const load = async () => {
    setLoading(true); setErr(null);
    try { const r = await api.get("/rid"); setData(r.data); }
    catch (e) { setErr(e.response?.data?.detail || "Errore caricamento"); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const doImport = async (file) => {
    if (!file) return;
    setImporting(true); setImportRes(null);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await api.post("/rid/import", fd, { headers: { "Content-Type": "multipart/form-data" } });
      setImportRes(r.data);
      await load();
    } catch (e) {
      alert("Errore import: " + (e.response?.data?.detail || e.message));
    } finally { setImporting(false); if (fileRef.current) fileRef.current.value = ""; }
  };

  const saveField = async (it, field, value) => {
    try {
      const r = await api.put(`/rid/${it.id}`, { [field]: value });
      setData((d) => ({ ...d, items: d.items.map((x) => x.id === it.id ? r.data : x) }));
    } catch (e) { alert("Errore salvataggio: " + (e.response?.data?.detail || e.message)); }
  };
  const revoca = (it) => saveField(it, "data_revoca", it.data_revoca ? "" : todayDmy());
  const del = async (it) => {
    if (!window.confirm(`Eliminare il mandato RID di ${it.cognome || it.nominativo}?`)) return;
    try { await api.delete(`/rid/${it.id}`); setData((d) => ({ ...d, items: d.items.filter((x) => x.id !== it.id) })); }
    catch (e) { alert("Errore: " + (e.response?.data?.detail || e.message)); }
  };

  const rows = useMemo(() => {
    const s = search.trim().toLowerCase();
    return (data.items || []).filter((it) => {
      if (soloNonCollegati && it.collegato) return false;
      if (soloAttivi && !it.attivo) return false;
      if (s && !`${it.cognome} ${it.nome} ${it.nominativo} ${it.iban} ${it.codice_fiscale || ""}`.toLowerCase().includes(s)) return false;
      return true;
    });
  }, [data, search, soloNonCollegati, soloAttivi]);

  return (
    <div data-testid="rid-alunni-page" style={{ padding: "12px 20px" }}>
      <div className="sw-page-title" style={{ display: "flex", alignItems: "center" }}>
        <h1>🏦 RID / Mandati bancari</h1>
        <div className="sw-breadcrumb">Tabelle Fisse &gt; RID</div>
        <input ref={fileRef} type="file" accept=".xls,.xlsx" style={{ display: "none" }}
          data-testid="rid-file-input" onChange={(e) => doImport(e.target.files?.[0])} />
        <button onClick={() => fileRef.current?.click()} disabled={importing} data-testid="rid-import-btn"
          title="Importa i mandati RID da file Excel (Nominativo / Settore classe / IBAN)"
          style={{ marginLeft: "auto", padding: "7px 14px", background: importing ? "#90a4ae" : "#00695c", color: "white", border: "none", borderRadius: 3, fontSize: 12, fontWeight: 700, cursor: importing ? "wait" : "pointer" }}>
          {importing ? "⏳ Import…" : "⬆ Importa Excel"}
        </button>
      </div>

      {importRes && (
        <div data-testid="rid-import-result" style={{ margin: "8px 0", padding: "8px 12px", background: "#e0f2f1", border: "1px solid #80cbc4", borderRadius: 4, fontSize: 13 }}>
          Import completato: <b>{importRes.creati}</b> creati, <b>{importRes.aggiornati}</b> aggiornati, <b>{importRes.collegati}</b> collegati ad alunno.
          {importRes.count_non_trovati > 0 && (
            <span style={{ color: "#c62828" }}> · <b>{importRes.count_non_trovati}</b> non collegati automaticamente (collegali a mano qui sotto).</span>
          )}
          <button onClick={() => setImportRes(null)} style={{ marginLeft: 8, border: "none", background: "transparent", color: "#00695c", cursor: "pointer", fontWeight: 700 }}>✕</button>
        </div>
      )}

      <div style={{ margin: "8px 0", background: "white", border: "1px solid #ccc", padding: 10, display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center" }}>
        <input placeholder="Cerca alunno, IBAN, C.F.…" value={search} onChange={(e) => setSearch(e.target.value)}
          data-testid="rid-search" style={{ padding: "5px 10px", border: "1px solid #ccc", fontSize: 12, width: 240 }} />
        <label style={{ fontSize: 12, display: "inline-flex", gap: 4, alignItems: "center", cursor: "pointer" }}>
          <input type="checkbox" checked={soloNonCollegati} onChange={(e) => setSoloNonCollegati(e.target.checked)} data-testid="rid-solo-noncoll" />
          Solo non collegati
        </label>
        <label style={{ fontSize: 12, display: "inline-flex", gap: 4, alignItems: "center", cursor: "pointer" }}>
          <input type="checkbox" checked={soloAttivi} onChange={(e) => setSoloAttivi(e.target.checked)} data-testid="rid-solo-attivi" />
          Solo attivi (non revocati)
        </label>
        <div style={{ marginLeft: "auto", fontSize: 12, color: "#444" }}>
          <b>{data.total}</b> mandati · <b>{data.count_attivi}</b> attivi · <span style={{ color: data.count_non_collegati ? "#c62828" : "#444" }}><b>{data.count_non_collegati}</b> da collegare</span>
        </div>
      </div>

      {err && <div style={{ margin: "0 0 8px", padding: 10, background: "#fff0f0", border: "1px solid #fcc", color: "#c00", fontSize: 12 }}>{err}</div>}

      <div style={{ background: "white", border: "1px solid #ccc", overflow: "auto", maxHeight: "72vh" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }} data-testid="rid-table">
          <thead style={{ background: "#00695c", color: "white", position: "sticky", top: 0, zIndex: 1 }}>
            <tr>
              <th style={{ padding: "6px 8px", textAlign: "center", width: 30 }}>#</th>
              <th style={{ padding: "6px 8px", textAlign: "left" }}>ALUNNO</th>
              <th style={{ padding: "6px 8px", textAlign: "left", width: 90 }}>SETT./CLASSE</th>
              <th style={{ padding: "6px 8px", textAlign: "left", width: 260 }}>IBAN</th>
              <th style={{ padding: "6px 8px", textAlign: "center", width: 120 }}>DATA ATTIVAZIONE</th>
              <th style={{ padding: "6px 8px", textAlign: "center", width: 120 }}>DATA REVOCA</th>
              <th style={{ padding: "6px 8px", textAlign: "center", width: 150 }}>AZIONI</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={7} style={{ padding: 20, textAlign: "center", color: "#888" }}>Caricamento…</td></tr>}
            {!loading && rows.length === 0 && <tr><td colSpan={7} style={{ padding: 30, textAlign: "center", color: "#888" }}>Nessun mandato. Usa <b>⬆ Importa Excel</b>.</td></tr>}
            {!loading && rows.map((it, i) => (
              <tr key={it.id} data-testid={`rid-row-${i}`} style={{ borderBottom: "1px solid #eee", background: it.attivo ? "white" : "#fafafa", opacity: it.attivo ? 1 : 0.65 }}>
                <td style={{ padding: "5px 8px", textAlign: "center", color: "#888", fontFamily: "monospace" }}>{i + 1}</td>
                <td style={{ padding: "5px 8px", fontWeight: 600, textTransform: "uppercase" }}>
                  {it.collegato
                    ? <span>{it.cognome} {it.nome}</span>
                    : <span style={{ color: "#c62828" }}>⚠ {it.nominativo} <span style={{ fontSize: 10, fontWeight: 400 }}>(non collegato)</span></span>}
                </td>
                <td style={{ padding: "5px 8px", fontFamily: "monospace" }}>
                  {it.collegato ? `${it.settore || ""} ${it.classe || ""}`.trim() || "—" : (it.settore_classe_import || "—")}
                </td>
                <td style={{ padding: "3px 6px" }}>
                  <input defaultValue={it.iban} key={`iban-${it.id}-${it.iban}`} data-testid={`rid-iban-${i}`}
                    onBlur={(e) => { const v = e.target.value.trim(); if (v !== (it.iban || "")) saveField(it, "iban", v); }}
                    style={{ width: "100%", padding: "4px 6px", border: "1px solid #ddd", borderRadius: 3, fontFamily: "monospace", fontSize: 11, boxSizing: "border-box" }} />
                </td>
                <td style={{ padding: "3px 6px", textAlign: "center" }}>
                  <input type="text" defaultValue={it.data_attivazione} key={`att-${it.id}-${it.data_attivazione}`} data-testid={`rid-attiv-${i}`}
                    placeholder="gg/mm/aaaa"
                    onBlur={(e) => { const v = e.target.value.trim(); if (v !== (it.data_attivazione || "")) saveField(it, "data_attivazione", v); }}
                    style={{ width: 96, padding: "4px 6px", border: "1px solid #ddd", borderRadius: 3, fontSize: 11, textAlign: "center" }} />
                </td>
                <td style={{ padding: "3px 6px", textAlign: "center" }}>
                  <input type="text" defaultValue={it.data_revoca} key={`rev-${it.id}-${it.data_revoca}`} data-testid={`rid-revoca-${i}`}
                    placeholder="—"
                    onBlur={(e) => { const v = e.target.value.trim(); if (v !== (it.data_revoca || "")) saveField(it, "data_revoca", v); }}
                    style={{ width: 96, padding: "4px 6px", border: "1px solid #ddd", borderRadius: 3, fontSize: 11, textAlign: "center", color: it.data_revoca ? "#c62828" : "#333", fontWeight: it.data_revoca ? 700 : 400 }} />
                </td>
                <td style={{ padding: "5px 8px", textAlign: "center", whiteSpace: "nowrap" }}>
                  {!it.collegato && (
                    <button onClick={() => setLinkRid(it)} data-testid={`rid-link-${i}`}
                      style={{ padding: "4px 8px", marginRight: 4, background: "#00695c", color: "white", border: "none", borderRadius: 3, fontSize: 11, fontWeight: 700, cursor: "pointer" }}>🔗 Collega</button>
                  )}
                  <button onClick={() => revoca(it)} data-testid={`rid-revoca-btn-${i}`}
                    title={it.data_revoca ? "Riattiva (azzera la revoca)" : "Revoca oggi"}
                    style={{ padding: "4px 8px", marginRight: 4, background: it.data_revoca ? "#2e7d32" : "#ef6c00", color: "white", border: "none", borderRadius: 3, fontSize: 11, fontWeight: 700, cursor: "pointer" }}>
                    {it.data_revoca ? "↩ Riattiva" : "⛔ Revoca"}
                  </button>
                  <button onClick={() => del(it)} data-testid={`rid-del-${i}`}
                    style={{ padding: "4px 8px", background: "#c62828", color: "white", border: "none", borderRadius: 3, fontSize: 11, fontWeight: 700, cursor: "pointer" }}>🗑</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {linkRid && (
        <LinkModal rid={linkRid} onClose={() => setLinkRid(null)}
          onLinked={(updated) => { setData((d) => ({ ...d, items: d.items.map((x) => x.id === updated.id ? updated : x) })); setLinkRid(null); load(); }} />
      )}
    </div>
  );
}
